export const API_URL = localStorage.getItem('API_URL') ?? process.env.REACT_APP_BACKEND_URL ?? ''
export const LS_RESTORE_PATH = 'TJ_RESTORE_PATH'
export const LS_DASHBOARD_FILTERS = 'TJ_DASHBOARD_FILTERS'
export const LS_DASHBOARD_SORT_PARAMS = 'TJ_DASHBOARD_SORT_PARAMS'
export const LS_ACCESS_TOKEN = 'TJ_CURRENT_ACCESS_TOKEN'
export const LS_TRADES_TABLE_COLUMNS = 'TJ_TRADES_TABLE_COLUMNS'

export const MS_IN_DAY = 86400000
export const MS_IN_HOUR = 3600000
